<template>
  <b-col md="12" class="mb-3">
    <b-card class="formCardDash">
      <div class="card-header">
        <h6 class="card-title mb-0">Enquiry Details</h6>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table-sm">
            <thead>
              <tr>
                <th>Enquiry No</th>
                <th>Enquiry Date</th>
                <th>Branch</th>
                <th>Sales Person</th>
                <th>Client Name</th>
                <th>Shipping Line</th>
                <th>POR</th>
                <th>POL</th>
                <th>POD</th>
                <th>Incoterm</th>
                <th>FCL/LCL</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(enquiry, index) in enquiryData" :key="index">
                <td>{{ enquiry.enquiryNo }}</td>
                <td>{{ formatDate(enquiry.enquiryDate) }}</td>
                <td>{{ enquiry.branchName }}</td>
                <td>{{ enquiry.salesPerson }}</td>
                <td>{{ enquiry.clientName }}</td>
                <td>{{ enquiry.shippingLine }}</td>
                <td>{{ enquiry.por }}</td>
                <td>{{ enquiry.pol }}</td>
                <td>{{ enquiry.pod }}</td>
                <td>{{ enquiry.incoterm }}</td>
                <td>{{ enquiry.fclLcl }}</td>
                <td>
                  <b-badge
                    :variant="
                      enquiry.status === 'Converted'
                        ? 'success'
                        : enquiry.status === 'Pending'
                        ? 'warning'
                        : 'secondary'
                    "
                    >{{ enquiry.status }}</b-badge
                  >
                </td>
              </tr>
              <tr v-if="enquiryData.length === 0">
                <td colspan="12" class="text-center text-muted">
                  No data available
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-card>
  </b-col>
</template>

<script>
import moment from "moment";

export default {
  name: "EnquirySection",
  props: {
    enquiryData: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return "-";
      return moment(date).format("DD-MM-YYYY");
    },
  },
};
</script>

<style scoped>
.formCardDash {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// EnquirySection.vue?2bc0b7db